var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRating(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_502_13535)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_502_13535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.63998 16.14C4.66998 15.79 4.75998 15.38 4.82998 14.96C4.99998 13.98 5.15998 13 5.33998 12.03C5.35998 11.89 5.30998 11.81 5.21998 11.72C4.25998 10.79 3.30998 9.86 2.34998 8.92C2.08998 8.67 1.96998 8.36 2.00998 8.01C2.07998 7.45 2.43998 7.09 3.00998 7.01C4.30998 6.82 5.61998 6.63 6.91998 6.45C7.07998 6.43 7.16998 6.35 7.23998 6.21C7.82998 5.02 8.40998 3.82 9.00998 2.63C9.30998 2.04 9.99998 1.83 10.57 2.16C10.79 2.29 10.93 2.48 11.04 2.71C11.61 3.87 12.19 5.03 12.75 6.19C12.83 6.36 12.94 6.43 13.13 6.46C14.43 6.64 15.72 6.83 17.02 7.02C17.48 7.09 17.81 7.34 17.94 7.79C18.07 8.23 17.97 8.63 17.63 8.95C16.68 9.87 15.74 10.79 14.8 11.7C14.68 11.82 14.64 11.93 14.67 12.1C14.9 13.39 15.12 14.68 15.34 15.97C15.46 16.67 15.06 17.22 14.36 17.33C14.15 17.36 13.95 17.31 13.76 17.21C12.58 16.59 11.4 15.98 10.23 15.35C10.07 15.26 9.94998 15.25 9.77998 15.35C8.61998 15.97 7.44998 16.57 6.27998 17.19C5.99998 17.34 5.70998 17.38 5.39998 17.28C4.92998 17.13 4.62998 16.72 4.62998 16.15L4.63998 16.14Z",
    fill: "#F4CD32"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_502_13535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(2 2)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_502_13535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 15.34,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/rating.12e611c770a6de835c465fdad01bbd06.svg";
export { ForwardRef as ReactComponent };